module.exports = __webpack_public_path__ + "static/pubsec-section-5-img-27826432f5ee9d75e47706e2d3cce817.png";